import * as React from "react";
import { clsx, cssClass, LightboxPropsProvider, makeUseContext } from "../../core/index.js";
import { cssPrefix } from "./utils.js";
import { ThumbnailsTrack } from "./ThumbnailsTrack.js";
import { resolveThumbnailsProps } from "./props.js";
export const ThumbnailsContext = React.createContext(null);
export const useThumbnails = makeUseContext("useThumbnails", "ThumbnailsContext", ThumbnailsContext);
export function ThumbnailsContextProvider({ children, ...props }) {
    const [visible, setVisible] = React.useState(true);
    const containerRef = React.useRef(null);
    const { ref, position } = resolveThumbnailsProps(props.thumbnails);
    const context = React.useMemo(() => ({
        visible,
        show: () => setVisible(true),
        hide: () => setVisible(false),
    }), [visible]);
    React.useImperativeHandle(ref, () => context, [context]);
    return (React.createElement(LightboxPropsProvider, { ...props },
        React.createElement(ThumbnailsContext.Provider, { value: context },
            React.createElement("div", { ref: containerRef, className: clsx(cssClass(cssPrefix()), cssClass(cssPrefix(`${position}`))) },
                ["start", "top"].includes(position) && React.createElement(ThumbnailsTrack, { containerRef: containerRef }),
                React.createElement("div", { className: cssClass(cssPrefix("wrapper")) }, children),
                ["end", "bottom"].includes(position) && React.createElement(ThumbnailsTrack, { containerRef: containerRef })))));
}
